/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'edit-clear': {
    width: 16,
    height: 16,
    viewBox: '0 0 34 34',
    data: '<path pid="0" d="M2.1 25.4v6.5h6.5L31.4 9 25 2.6 2.1 25.4zM25.7.3l8 8c.4.4.4 1.1 0 1.5L9.8 33.7c-.2.2-.5.3-.8.3H1c-.5 0-1-.5-1-1.1v-8c0-.3.1-.6.3-.8L24.2.3c.4-.4 1.1-.4 1.5 0z"/>'
  }
})
